import Ajv from 'ajv';
import {
  BlankIAMConfiguration,
  IAMConfigurationFields,
} from './configuration/IamConfig';
import {
  BlankListingConfiguration,
  ListingConfigurationFields,
} from './configuration/ListingConfig';
import {
  BlankOMConfiguration,
  OMConfigurationFields,
} from './configuration/OMConfig';
import {
  BlankPSConfiguration,
  PSConfigurationFields,
} from './configuration/PSConfig';
import {
  BlankSearchConfiguration,
  SearchConfigurationFields,
} from './configuration/SearchConfig';
import {
  BlankCRMConfiguration,
  CRMConfigurationFields,
} from './configuration/CRMConfig';
import {
  BlankDCAConfiguration,
  DCAConfigurationFields,
} from './configuration/DCAConfig';
import {
  BlankImageConfiguration,
  ImageConfigurationFields,
} from './configuration/ImageConfig';
import {
  BlankLocationConfiguration,
  LocationConfigurationFields,
} from './configuration/LocationConfig';
import {
  BlankNotificationConfiguration,
  NotificationConfigurationFields,
} from './configuration/NotificationConfig';
import {
  BlankPPMConfiguration,
  PPMConfigurationFields,
} from './configuration/PPMConfig';
import {
  BlankPvisConfiguration,
  PVISConfigurationFields,
} from './configuration/PVISConfig';
import {
  BlankTrackerConfiguration,
  TrackerConfigurationFields,
} from './configuration/TrackerConfig';
import {
  BlankUSConfiguration,
  USConfigurationFields,
} from './configuration/USConfig';
import {
  BlankWMSConfiguration,
  WMSConfigurationFields,
} from './configuration/WMSConfig';
import {
  BlankSellerConfiguration,
  SellerConfigurationFields,
} from './configuration/SellerConfig';
import {
  DiscoveryConfigurationFields,
  BlankDiscoveryConfiguration,
} from './configuration/DiscoveryConfig';
import {
  BlankMaiaConfiguration,
  MaiaConfigurationFields,
} from './configuration/MaiaConfig';
import {
  BlankFirebaseConfiguration,
  FirebaseConfigurationFields,
} from './configuration/FirebaseConfig';
import {
  BlankPolicyConfiguration,
  PolicyConfigurationFields,
} from './configuration/PolicyConfig';
import {
  BlankFinanceConfiguration,
  FinanceConfigurationFields,
} from './configuration/FinanceConfig';
import {
  BlankTicketConfiguration,
  TicketConfigurationFields,
} from './configuration/TicketConfig';
import {
  BaseConfig,
  ServiceConfigDescription,
  ServiceConfigIntegrationDescription,
} from './ServiceConfig';
import {
  BlankCatalogConfiguration,
  CatalogConfigurationFields,
} from './configuration/CatalogConfig';
import {
  BlankCartConfiguration,
  CartConfigurationFields,
} from './configuration/CartConfig';
import {
  BlankPosConfiguration,
  PosConfigurationFields,
} from './configuration/PosConfig';
import {
  BlankCovConfiguration,
  CovConfigurationFields,
} from './configuration/CovConfig';
import {
  BlankHestiaConfiguration,
  HestiaConfigurationFields,
} from './configuration/HestiaConfig';
import {
  BankConfigurationFields,
  BlankBankConfiguration,
} from './configuration/BankConfig';
import {
  ApolloConfigurationFields,
  BlankApolloConfiguration,
} from './configuration/ApolloConfig';
import {
  LoyaltyConfigurationFields,
  BlankLoyaltyConfiguration,
} from './configuration/LoyaltyConfig';
import {
  BlankCovBffConfiguration,
  CovBffConfigurationFields,
} from './configuration/CovBffConfig';
import {
  BlankIrisConfiguration,
  IrisConfigurationFields,
} from './configuration/IrisConfig';
import {
  ApprovalConfigurationFields,
  BlankApprovalConfiguration,
} from './configuration/ApprovalConfig';
import {
  BlankPaymentControllerConfiguration,
  PaymentControllerConfigurationFields,
} from './configuration/PaymentControllerConfig';
import {
  BlankIdAdminConfiguration,
  IdAdminConfigurationFields,
} from './configuration/\u001DIdAdminConfig';
import {
  BlankUserCornerConfiguration,
  UserCornerConfigurationFields,
} from './configuration/UserCornerConfig';
import {
  BlankTempiConfiguration,
  TempiConfigurationFields,
} from './configuration/TempiConfig';
import { BlankReferrerConfiguration, ReferrerConfigurationFields } from './configuration/ReferrerConfig';
import { BlankSalePortalBffConfiguration, SalePortalBffConfigurationFields } from './configuration/SalePortalBffConfig';
import { BlankUserPrivacyPolicyConfiguration, UserPrivacyPolicyConfigurationFields } from './configuration/UserPrivacyPolicyConfig';
import { BlankTempoConfiguration, TempoConfigurationFields } from './configuration/TempoConfig';
import { BlankOmniBffConfiguration, OmniBffConfigurationFields } from './configuration/OmniBffConfig';
import {
  BlankWordPressConfiguration,
  WordPressConfigurationFields,
} from './configuration/WordPressConfig';
import {
  BlankFileConfiguration,
  FileConfigurationFields,
} from './configuration/FileConfig';
import {
  BlankSmartBannerConfiguration,
  SmartBannerConfigurationFields,
} from './configuration/SmartBannerConfig';

export enum ServiceName {
  Iam = 'iam',
  Tracker = 'tracker',
  Ps = 'ps',
  Discovery = 'discovery',
  Listing = 'listing',
  Search = 'search',
  Ppm = 'ppm',
  Seller = 'seller',
  Image = 'image',
  Om = 'om',
  Cov = 'cov',
  CovBff = 'cov_bff',
  Pvis = 'pvis',
  Crm = 'crm',
  Dca = 'dca',
  Location = 'location',
  Notification = 'notification',
  Us = 'us',
  Wms = 'wms',
  Maia = 'maia',
  Firebase = 'firebase',
  Policy = 'policy',
  Finance = 'finance',
  Ticket = 'ticket',
  Catalog = 'catalog',
  Cart = 'cart',
  Pos = 'pos',
  Hestia = 'hestia',
  Bank = 'bank',
  Apollo = 'apollo',
  Loyalty = 'loyalty',
  Iris = 'iris',
  Approval = 'approval',
  PaymentController = 'payment_controller',
  IdAdmin = 'id_admin',
  UserCorner = 'user_corner',
  Tempi = 'tempi',
  Tempo = 'tempo',
  Referrer = 'referrer',
  SalePortalBff = 'sale_portal_bff',
  UserPrivacyPolicy = 'user_privacy_policy',
  OmniBff = 'omni_bff',
  WordPress = 'word_press',
  File = 'file',
  SmartBanner = 'smart_banner',
}

export function getBlankDetailConfig(serviceName: ServiceName): BaseConfig {
  switch (serviceName) {
    case ServiceName.Iam:
      return BlankIAMConfiguration;
    case ServiceName.Listing:
      return BlankListingConfiguration;
    case ServiceName.Om:
      return BlankOMConfiguration;
    case ServiceName.Cov:
      return BlankCovConfiguration;
    case ServiceName.CovBff:
      return BlankCovBffConfiguration;
    case ServiceName.Ps:
      return BlankPSConfiguration;
    case ServiceName.Search:
      return BlankSearchConfiguration;
    case ServiceName.Crm:
      return BlankCRMConfiguration;
    case ServiceName.Dca:
      return BlankDCAConfiguration;
    case ServiceName.Image:
      return BlankImageConfiguration;
    case ServiceName.Location:
      return BlankLocationConfiguration;
    case ServiceName.Notification:
      return BlankNotificationConfiguration;
    case ServiceName.Ppm:
      return BlankPPMConfiguration;
    case ServiceName.Pvis:
      return BlankPvisConfiguration;
    case ServiceName.Tracker:
      return BlankTrackerConfiguration;
    case ServiceName.Us:
      return BlankUSConfiguration;
    case ServiceName.Wms:
      return BlankWMSConfiguration;
    case ServiceName.Seller:
      return BlankSellerConfiguration;
    case ServiceName.Discovery:
      return BlankDiscoveryConfiguration;
    case ServiceName.Maia:
      return BlankMaiaConfiguration;
    case ServiceName.Firebase:
      return BlankFirebaseConfiguration;
    case ServiceName.Policy:
      return BlankPolicyConfiguration;
    case ServiceName.Finance:
      return BlankFinanceConfiguration;
    case ServiceName.Ticket:
      return BlankTicketConfiguration;
    case ServiceName.Catalog:
      return BlankCatalogConfiguration;
    case ServiceName.Cart:
      return BlankCartConfiguration;
    case ServiceName.Pos:
      return BlankPosConfiguration;
    case ServiceName.Hestia:
      return BlankHestiaConfiguration;
    case ServiceName.Bank:
      return BlankBankConfiguration;
    case ServiceName.Apollo:
      return BlankApolloConfiguration;
    case ServiceName.Loyalty:
      return BlankLoyaltyConfiguration;
    case ServiceName.Iris:
      return BlankIrisConfiguration;
    case ServiceName.Approval:
      return BlankApprovalConfiguration;
    case ServiceName.PaymentController:
      return BlankPaymentControllerConfiguration;
    case ServiceName.IdAdmin:
      return BlankIdAdminConfiguration;
    case ServiceName.UserCorner:
      return BlankUserCornerConfiguration;
    case ServiceName.Tempi:
      return BlankTempiConfiguration;
    case ServiceName.Tempo:
      return BlankTempoConfiguration;
    case ServiceName.Referrer:
      return BlankReferrerConfiguration;
    case ServiceName.SalePortalBff:
      return BlankSalePortalBffConfiguration;
    case ServiceName.UserPrivacyPolicy:
      return BlankUserPrivacyPolicyConfiguration;
    case ServiceName.OmniBff:
      return BlankOmniBffConfiguration;
    case ServiceName.WordPress:
      return BlankWordPressConfiguration;
    case ServiceName.File:
      return BlankFileConfiguration;
    case ServiceName.SmartBanner:
      return BlankSmartBannerConfiguration;
    default:
      throw Error(`Invalid service name ${serviceName}`);
  }
}

export function getBlankServiceIntegrationConfig(
  serviceName: ServiceName
): ServiceConfigIntegrationDescription<BaseConfig> {
  return {
    isActive: true,
    data: getBlankServiceConfigData(serviceName),
    extra: {},
  };
}

export function getBlankServiceConfig(
  serviceName: ServiceName
): ServiceConfigDescription<BaseConfig> {
  return {
    data: getBlankServiceConfigData(serviceName),
    extra: {},
  };
}

export function getBlankServiceConfigData(
  serviceName: ServiceName
): BaseConfig {
  return getBlankDetailConfig(serviceName);
}

export function getServiceConfigFields<T extends BaseConfig>(
  serviceName: ServiceName
): (keyof T)[] {
  switch (serviceName) {
    case ServiceName.Iam:
      return IAMConfigurationFields as (keyof T)[];
    case ServiceName.Listing:
      return ListingConfigurationFields as (keyof T)[];
    case ServiceName.Om:
      return OMConfigurationFields as (keyof T)[];
    case ServiceName.Cov:
      return CovConfigurationFields as (keyof T)[];
    case ServiceName.CovBff:
      return CovBffConfigurationFields as (keyof T)[];
    case ServiceName.Ps:
      return PSConfigurationFields as (keyof T)[];
    case ServiceName.Search:
      return SearchConfigurationFields as (keyof T)[];
    case ServiceName.Crm:
      return CRMConfigurationFields as (keyof T)[];
    case ServiceName.Dca:
      return DCAConfigurationFields as (keyof T)[];
    case ServiceName.Image:
      return ImageConfigurationFields as (keyof T)[];
    case ServiceName.Location:
      return LocationConfigurationFields as (keyof T)[];
    case ServiceName.Notification:
      return NotificationConfigurationFields as (keyof T)[];
    case ServiceName.Ppm:
      return PPMConfigurationFields as (keyof T)[];
    case ServiceName.Pvis:
      return PVISConfigurationFields as (keyof T)[];
    case ServiceName.Tracker:
      return TrackerConfigurationFields as (keyof T)[];
    case ServiceName.Us:
      return USConfigurationFields as (keyof T)[];
    case ServiceName.Wms:
      return WMSConfigurationFields as (keyof T)[];
    case ServiceName.Seller:
      return SellerConfigurationFields as (keyof T)[];
    case ServiceName.Discovery:
      return DiscoveryConfigurationFields as (keyof T)[];
    case ServiceName.Maia:
      return MaiaConfigurationFields as (keyof T)[];
    case ServiceName.Firebase:
      return FirebaseConfigurationFields as (keyof T)[];
    case ServiceName.Policy:
      return PolicyConfigurationFields as (keyof T)[];
    case ServiceName.Finance:
      return FinanceConfigurationFields as (keyof T)[];
    case ServiceName.Ticket:
      return TicketConfigurationFields as (keyof T)[];
    case ServiceName.Catalog:
      return CatalogConfigurationFields as (keyof T)[];
    case ServiceName.Cart:
      return CartConfigurationFields as (keyof T)[];
    case ServiceName.Pos:
      return PosConfigurationFields as (keyof T)[];
    case ServiceName.Hestia:
      return HestiaConfigurationFields as (keyof T)[];
    case ServiceName.Bank:
      return BankConfigurationFields as (keyof T)[];
    case ServiceName.Apollo:
      return ApolloConfigurationFields as (keyof T)[];
    case ServiceName.Loyalty:
      return LoyaltyConfigurationFields as (keyof T)[];
    case ServiceName.Iris:
      return IrisConfigurationFields as (keyof T)[];
    case ServiceName.Approval:
      return ApprovalConfigurationFields as (keyof T)[];
    case ServiceName.PaymentController:
      return PaymentControllerConfigurationFields as (keyof T)[];
    case ServiceName.IdAdmin:
      return IdAdminConfigurationFields as (keyof T)[];
    case ServiceName.UserCorner:
      return UserCornerConfigurationFields as (keyof T)[];
    case ServiceName.Tempi:
      return TempiConfigurationFields as (keyof T)[];
    case ServiceName.Tempo:
      return TempoConfigurationFields as (keyof T)[];
    case ServiceName.Referrer:
      return ReferrerConfigurationFields as (keyof T)[];
    case ServiceName.SalePortalBff:
      return SalePortalBffConfigurationFields as (keyof T)[];
    case ServiceName.UserPrivacyPolicy:
      return UserPrivacyPolicyConfigurationFields as (keyof T)[];
    case ServiceName.OmniBff:
      return OmniBffConfigurationFields as (keyof T)[];
    case ServiceName.WordPress:
      return WordPressConfigurationFields as (keyof T)[];
    case ServiceName.File:
      return FileConfigurationFields as (keyof T)[];
    case ServiceName.SmartBanner:
      return SmartBannerConfigurationFields as (keyof T)[];
    default:
      return [];
  }
}

export function validateServiceConfigData(
  serviceName: ServiceName,
  data: any
): {
  isValid: boolean;
  error: string;
} {
  let schema;

  switch (serviceName) {
    case ServiceName.Apollo:
      schema = require('../../data/terra/configuration/schema/apollo_config_schema.json');
      break;
    case ServiceName.Bank:
      schema = require('../../data/terra/configuration/schema/bank_config_schema.json');
      break;
    case ServiceName.Cov:
      schema = require('../../data/terra/configuration/schema/cov_config_schema.json');
      break;
    case ServiceName.Discovery:
      schema = require('../../data/terra/configuration/schema/discovery_config_schema.json');
      break;
    case ServiceName.Firebase:
      schema = require('../../data/terra/configuration/schema/firebase_config_schema.json');
      break;
    case ServiceName.Iam:
      schema = require('../../data/terra/configuration/schema/iam_config_schema.json');
      break;
    case ServiceName.Listing:
      schema = require('../../data/terra/configuration/schema/listing_config_schema.json');
      break;
    case ServiceName.Om:
      schema = require('../../data/terra/configuration/schema/om_config_schema.json');
      break;
    case ServiceName.Policy:
      schema = require('../../data/terra/configuration/schema/policy_config_schema.json');
      break;
    case ServiceName.Ppm:
      schema = require('../../data/terra/configuration/schema/ppm_config_schema.json');
      break;
    case ServiceName.Ps:
      schema = require('../../data/terra/configuration/schema/ps_config_schema.json');
      break;
    case ServiceName.Search:
      schema = require('../../data/terra/configuration/schema/search_config_schema.json');
      break;
    case ServiceName.Tracker:
      schema = require('../../data/terra/configuration/schema/tracker_config_schema.json');
      break;
    case ServiceName.Us:
      schema = require('../../data/terra/configuration/schema/user_config_schema.json');
      break;
    case ServiceName.Loyalty:
      schema = require('../../data/terra/configuration/schema/loyalty_config_schema.json');
      break;
    case ServiceName.Cart:
      schema = require('../../data/terra/configuration/schema/cart_config_schema.json');
      break;
    case ServiceName.Notification:
      schema = require('../../data/terra/configuration/schema/notification_config_schema.json');
      break;
    case ServiceName.CovBff:
      schema = require('../../data/terra/configuration/schema/cov_bff_config_schema.json');
      break;
    case ServiceName.PaymentController:
      schema = require('../../data/terra/configuration/schema/payment_controller_schema.json');
      break;
    case ServiceName.Hestia:
      schema = require('../../data/terra/configuration/schema/hestia_config_schema.json');
      break;
    case ServiceName.UserCorner:
      schema = require('../../data/terra/configuration/schema/user_corner_config_schema.json');
      break;
    case ServiceName.Tempi:
      schema = require('../../data/terra/configuration/schema/tempi_config_schema.json');
      break;
    case ServiceName.Tempo:
      schema = require('../../data/terra/configuration/schema/tempo_config_schema.json');
      break;
    case ServiceName.Referrer:
      schema = require('../../data/terra/configuration/schema/referrer_config_schema.json');
      break;
    case ServiceName.OmniBff:
      schema = require('../../data/terra/configuration/schema/omni_bff_config_schema.json');
      break;
    case ServiceName.WordPress:
      schema = require('../../data/terra/configuration/schema/word_press_config_schema.json');
      break;
    case ServiceName.File:
      schema = require('../../data/terra/configuration/schema/file_config_schema.json');
      break;
    case ServiceName.SmartBanner:
      schema = require('../../data/terra/configuration/schema/smart_banner_config_schema.json');
      break;
    default:
      schema = require('../../data/terra/configuration/schema/common_config_schema.json');
      break;
  }

  const ajv = new Ajv({
    allErrors: true,
    verbose: true,
  });
  const result = ajv.validate(schema, data);
  return {
    isValid: !!result,
    error: customAjvErrorsText(ajv),
  };
}

function customAjvErrorsText(ajv: Ajv.Ajv): string {
  if (!ajv.errors) return 'No errors';
  var separator = '; ';

  var text = '';
  for (var i = 0; i < ajv.errors.length; i++) {
    var e = ajv.errors[i];
    if (e) {
      text += e.dataPath + ' ' + e.message;
      text += getExtraAjvErrorMessage(e);
      text += separator;
    }
  }
  return text.slice(0, -separator.length);
}

function getExtraAjvErrorMessage(e: Ajv.ErrorObject): string {
  if (e.keyword === 'enum') {
    return ': ' + (e.params as Ajv.EnumParams).allowedValues.join(', ');
  } else {
    return '';
  }
}
